import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/contexts/AuthContext.tsx";
import { ThemeProvider } from "@/components/theme-provider.tsx";
import { RandomBackgroundColorProvider } from "@/contexts/RandomBgColorContext.tsx";
import { Header } from "@/components/header/Header.tsx";
import { Toaster } from "@/components/ui/toaster.tsx";
import { Footer } from "@/components/Footer.tsx";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.ts";

import "./index.css";
import App from "./App.tsx";

const el = document.getElementById("root");
const root = ReactDOM.createRoot(el as HTMLElement);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <I18nextProvider i18n={i18n}>
            <React.Suspense fallback={null}>
              <RandomBackgroundColorProvider>
                <BrowserRouter>
                <div className="min-h-screen flex flex-col">
                  <Header />
                  <div className="flex-grow">
                    <App />
                  </div>
                  <Footer />
                  <Toaster />
                </div>
                </BrowserRouter>
              </RandomBackgroundColorProvider>
            </React.Suspense>
          </I18nextProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
